import { DOCUMENTS } from '@/shared/components/input-file/utils';

// The rules of the CV field (TCSTC-4763). The help text and the two error
// messages are built from these values, so they cannot disagree with the check.
export const CV_ACCEPTED_EXTENSIONS = [
  DOCUMENTS['application/pdf'],
  DOCUMENTS[
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],
].join(',');

// In KB of 1,024 bytes (5,120,000 bytes). It is the backend limit of
// TCSTC-4765 (cv_file_policy.py, CV_MAX_SIZE_BYTES): do not change one alone.
export const MAX_SIZE_FILE = 5000;

const WORD_LABELS: Record<string, string> = {
  '.doc': 'Word (.doc)',
  '.docx': 'Word (.docx)',
};

// ".pdf,.docx" + "o" -> "PDF o Word (.docx)"
export const formatAcceptedFormats = (accept: string, or: string) => {
  const labels = accept
    .split(',')
    .map(token => token.trim().toLowerCase())
    .filter(Boolean)
    .map(token => WORD_LABELS[token] ?? token.replace('.', '').toUpperCase());

  if (labels.length < 2) {
    return labels.join('');
  }

  return `${labels.slice(0, -1).join(', ')} ${or} ${labels[labels.length - 1]}`;
};

// 5000 -> "5 MB"
export const formatMaxSize = (kb: number) => `${kb / 1000} MB`;
